import React from 'react'
import {fieldsToHtml} from '../../util/util-fields'
import {FieldsManager} from '../../../data/services/fields'
import {getCountryCodes} from "../../util/countryCodes";
import {getLookup} from "../../util/util-helpers";


export function getPhoneFieldsKeyValues(fields) {
    return fields.map((phone, i) => {
        phone.IsPrimary.value = (i === 0) ? 1 : 0
        return FieldsManager.getFieldKeyValues(phone)
    })
}

export default function PhoneFields(props) {
    const {translate} = props

    const phoneFields = props?.phonesFields?.map((item, i) => {
        item.PhoneNumber.metadata.label = i === 0 ? `main_phone_primary` : `phone_number`

        const itemToHtml = fieldsToHtml(Object.values(Object.assign({}, item)), translate, (name, value) => props.handleItemInputChange(i, name, value), {
            PhoneTypeID: getLookup('PhoneType'),
            AreaCode: getCountryCodes()
        })

        return (
            <React.Fragment key={i}>
                <div className="border border-tm-gray-200 text-right p-4 rounded-card relative">
                    {i !== 0 && (
                        <button className="btn icon-button size-5 top-1 right-1 color-primary absolute flex items-center justify-center"
                                onClick={() => props.removePhoneField(i)}>
                            <i className="simple-icon-close"/>
                        </button>
                    )}

                    <div className="grid gap-4 grid-cols-1 pb-5">
                        {itemToHtml}
                    </div>
                </div>
            </React.Fragment>
        )
    })

    return (
        <React.Fragment>
            {phoneFields}
        </React.Fragment>
    )
}
